import { render } from "./Footer-Bosa.vue?vue&type=template&id=9bcce6f0"
import script from "./Footer-Bosa.vue?vue&type=script&lang=js"
export * from "./Footer-Bosa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__